<div class="lista-vertical">

  @if (itens.length > 0) {
    <p-accordion [multiple]="true">
      @for (item of itens; track item; let ci = $index) {
        <p-accordion-panel [value]="ci">
          <p-accordion-header>
            <div class="item-cabecalho">
              <input pInputText class="item-titulo" [id]="'itemNome' + ci" [(ngModel)]="item.nome"
                placeholder="Nome do item de vistoria"
                (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                <button mat-icon-button matTooltip="Duplicar item de vistoria"
                  (mousedown)="$event.stopPropagation()" (click)="duplicarItem(item); $event.stopPropagation()">
                  <i class="pi pi-copy"></i>
                </button>
                <button mat-icon-button matTooltip="Remover item de vistoria"
                  (mousedown)="$event.stopPropagation()" (click)="confirmarRemocao(item); $event.stopPropagation()">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <h4 class="atributos-titulo accent-color">Atributos</h4>
              @for (atributo of item.atributos; track atributo; let ai = $index) {
                <div class="linha-item">
                  <div class="linha-item-corpo">
                    <p-floatLabel variant="on" class="campo-nome">
                      <input pInputText [id]="'atributoNome' + ci + '-' + ai" [(ngModel)]="atributo.nome" />
                      <label [for]="'atributoNome' + ci + '-' + ai">Nome do atributo</label>
                    </p-floatLabel>
                    <p-checkbox [binary]="true" [(ngModel)]="atributo.ehFoto" [inputId]="'atributoEhFoto' + ci + '-' + ai"></p-checkbox>
                    <label [for]="'atributoEhFoto' + ci + '-' + ai" class="label-checkbox">É foto</label>
                  </div>
                  <div class="linha-item-acoes">
                    <button mat-icon-button matTooltip="Subir" [disabled]="ai === 0" (click)="moverAtributo(item, atributo, -1)">
                      <i class="pi pi-chevron-up"></i>
                    </button>
                    <button mat-icon-button matTooltip="Descer" [disabled]="ai === item.atributos.length - 1" (click)="moverAtributo(item, atributo, 1)">
                      <i class="pi pi-chevron-down"></i>
                    </button>
                    <button mat-icon-button matTooltip="Remover" (click)="removerAtributo(item, atributo)">
                      <i class="pi pi-trash"></i>
                    </button>
                  </div>
                </div>
              }
              <button mat-stroked-button class="btn-adicionar" (click)="adicionarAtributo(item)">
                <i class="pi pi-plus"></i> Adicionar atributo
              </button>
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>
    }

    <button mat-stroked-button class="btn-adicionar" (click)="adicionar()">
      <i class="pi pi-plus"></i> Adicionar item de vistoria
    </button>

  </div>
